<template>
    <div id="app" style="font-family: poppins;min-height: 100vh;">

      <main>

      <!--
        - #SIDEBAR
      -->

      <!-- <aside class="sidebar" data-sidebar>

      </aside> -->


      <!-- <nav style="font-size: 20px;" class="navbar">
        <router-link to="/" class="nav-link"><i class="el-icon-house"></i>  Home</router-link>
        <router-link to="/books" class="nav-link"><i class="el-icon-files"></i> Book List</router-link>
        <router-link to="/allBooks" class="nav-link"><i class="el-icon-film"></i>  All Books</router-link>
      </nav> -->


      <!--
      - #main-content
    -->

    <div class="main-content">

      <nav class="navbar animated-border">

        <ul class="navbar-list">

          <li class="navbar-item">
            <router-link to="/"><button class="navbar-link " data-nav-link><i class="el-icon-house"></i>  Home</button></router-link>
          </li>

          <li class="navbar-item">
            <router-link to="/books" class="nav-link"><button class="navbar-link" data-nav-link><i class="el-icon-files"></i> Book List</button></router-link>
          </li>

          <li class="navbar-item">
            <router-link to="/allBooks" class="nav-link"><button class="navbar-link" data-nav-link><i class="el-icon-film"></i>  All Books</button></router-link>
          </li>

          <!-- <li class="navbar-item">
            <button class="navbar-link" data-nav-link><router-link to="/" class="nav-link"><i class="el-icon-house"></i>  Home</router-link></button>
          </li> -->

          <!-- <li class="navbar-item">
            <button class="navbar-link" data-nav-link><router-link to="/" class="nav-link"><i class="el-icon-house"></i>  Home</router-link></button>
          </li> -->

          <!-- <li class="navbar-item">
            <button class="navbar-link" data-nav-link>Contact</button>
          </li> -->

        </ul>
      </nav>
      
      <router-view></router-view>
      
      <footer>
        <p>&copy; {{ currentYear }} Kede Book Blog. All rights reserved.</p>
      </footer>
    
    </div>
    </main>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    computed: {
      currentYear() {
        return new Date().getFullYear();
      }
    }
  }
  </script>
  
  <style>
  /* #app {
    font-family: Arial, sans-serif;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: #2b2b2840;
  }
  
  nav {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    background-color: #f4f4f4;
    padding: 10px;
  }
  
  .nav-link {
    margin: 0 15px;
    text-decoration: none;
    color: #333;
    font-weight: bold;
  }
  
  .nav-link:hover {
    color: #666;
  } */
  
  footer {
    text-align: center;
    margin-top: 30px;
    padding: 20px;
    background-color: #f4f4f4;
  }
  </style>